/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Alert, AlertTitle, Box, Collapse } from '@mui/material';

interface ErrorAlertProps {
  error: string | Error | null;
  title?: string;
  onClose?: () => void;
}

/**
 * Error alert component for displaying error messages
 */
export const ErrorAlert: React.FC<ErrorAlertProps> = ({ 
  error, 
  title = 'Error',
  onClose 
}) => {
  if (!error) return null;

  const errorMessage = typeof error === 'string' 
    ? error 
    : error.message || 'An unexpected error occurred';

  return (
    <Box sx={{ mb: 2 }}>
      <Collapse in={!!error}>
        <Alert 
          severity="error" 
          onClose={onClose}
          sx={{ mb: 2 }}
        >
          <AlertTitle>{title}</AlertTitle>
          {errorMessage}
        </Alert>
      </Collapse>
    </Box>
  );
};

export default ErrorAlert;
